export enum ReportFileFormat {
    xls = "xls",
    csv = "csv",
}